// fetch-interceptor.ts
import wsClient from './websocket-client';

// Păstrăm referința originală la fetch
const originalFetch = window.fetch;

window.fetch = async (input: RequestInfo, init?: RequestInit) => {
  try {
    // Executăm fetch-ul normal
    const response = await originalFetch(input, init);

    // Determinăm metoda
    const method = (init?.method || 'GET').toUpperCase();

    // Emit WS pentru metode care modifică datele
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      wsClient?.emit('api_call', {
        url: typeof input === 'string' ? input : input.url,
        method,
        timestamp: new Date().toISOString(),
      });
    }

    return response;
  } catch (err) {
    console.error('Eroare la fetch:', err);
    throw err;
  }
};
